import { render, staticRenderFns } from "./JokyoShokai.vue?vue&type=template&id=56466612&scoped=true"
import script from "./JokyoShokai.vue?vue&type=script&lang=js"
export * from "./JokyoShokai.vue?vue&type=script&lang=js"
import style0 from "./JokyoShokai.vue?vue&type=style&index=0&id=56466612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56466612",
  null
  
)

export default component.exports